import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {InspectionForm} from 'src/pages/Modules/Inspections/shared/InspectionForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const InspectionEditPage: React.FC = () => {
  const {id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Inspections}>
      <InspectionForm id={Number(id)} mode="edit" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InspectionsEdit(':id'),
  element: <InspectionEditPage />,
  module: ModuleEnum.Inspections,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
